import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import '@/libs/rem'
import '@/assets/css/reset.css'
import '@/assets/css/base.css'

const SDK_INIT_TIMEOUT = 3000;
const pendingCustomEvents = [];
let hasRendered = false;

window.erwan_stat = {
  customEvent: (...args) => {
    pendingCustomEvents.push(args);
  },
};

const renderApp = () => {
  if (hasRendered) return;
  hasRendered = true;
  ReactDOM.render(<App />, document.getElementById('root'));
};

const renderTimer = setTimeout(renderApp, SDK_INIT_TIMEOUT);

import('erwan-stat').then((EWStat) => {
  const Stat = EWStat.default || EWStat;
  const project = 'off_web';
  const subProject = 'qiniu_web';
  const elephantConf = {
    elephantId: 'd5e9b808-ae60-432b-b80e-cda454a17b50',
    enableAction: true,
    enableError: true,
    enableXhr: true,
    enablePerformance: true,
    xhr: {
      includes: [],
      excludes: [
        'cta.feierlaiedu.com',
        'cta.feierlaiedu.cn',
        'testctai.qn76.cn',
        'cta-bak.feierlaiedu.cn',
        'umini.shujupie.com',
        'sentry.feierlaiedu.com',
        'testkcxtr.qn76.cn',
         'testctai.qn76.cn',
                'cta.feierlaiedu.com',
                'arms-retcode.aliyuncs.com',
                'sentry.feierlaiedu.com',
                'testkcxtr.qn76.cn',
                'wrapi.feierlaiedu.com',
                '/sockjs-node/',
                'erwan-frontend.cn-zhangjiakou.log.aliyuncs.com',
                'testlcsg.qn76.cn',
                'lcsgr.feierlaiedu.com',
                // AI 助手 SSE 长连接 + 同域 liveCoze 业务接口整体不上报
                // 覆盖 dev/test/pre/prod 三个环境的启牛直播域名
                // 涉及: startChatStream (SSE) / audioSpeech (SSE) / conversations / getCustomerChatRecordList / cancelChatStream
                'devlg.qn76.cn',
                'testlg.qn76.cn',
                'lg.frlqn.cn',
      ],
    },
  };

  const tracker = new Stat(elephantConf);
  return Promise.resolve(tracker.init(project, subProject)).then(() => {
    window.erwan_stat = tracker;
    pendingCustomEvents.forEach((args) => tracker.customEvent(...args));
    pendingCustomEvents.length = 0;
    clearTimeout(renderTimer);
    renderApp();
  });
}).catch(() => undefined);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
